"use strict";

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/mnt/ephemeral/jenkins/workspace/lucid-co-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/mnt/ephemeral/jenkins/workspace/lucid-co-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.symbol");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 1;\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @jsx jsx */

var core_1 = require("@emotion/core");

var react_1 = require("react");

var react_player_1 = __importDefault(require("react-player"));

var video_play_button_1 = __importDefault(require("../video-play-button/video-play-button"));

var styled_1 = __importDefault(require("../../../theme/styled"));

var VideoPlaceholder = styled_1.default('div')(_templateObject());
var VideoOverlay = styled_1.default('div')(_templateObject2());

var VideoPlayer = function VideoPlayer(_a) {
  var className = _a.className,
      url = _a.url,
      placeholder = _a.placeholder,
      playing = _a.playing,
      _a$onClick = _a.onClick,
      _onClick = _a$onClick === void 0 ? function () {
    return;
  } : _a$onClick,
      _a$ratio = _a.ratio,
      ratio = _a$ratio === void 0 ? 'wide' : _a$ratio,
      rest = __rest(_a, ["className", "url", "placeholder", "playing", "onClick", "ratio"]);

  var _react_1$useState = react_1.useState(!playing),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      overlayVisible = _react_1$useState2[0],
      setOverlayVisible = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(playing),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      isPlaying = _react_1$useState4[0],
      setIsPlaying = _react_1$useState4[1];

  react_1.useEffect(function () {
    if (playing) {
      setOverlayVisible(false);
      setIsPlaying(true);
    }
  }, [playing]);
  var reactPlayerCss = core_1.css({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0
  });
  var videoContainerCss = core_1.css({
    display: 'block',
    padding: 0,
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '5px',
    paddingTop: ratio === 'wide' ? '56.25%' : '100%'
  });
  return core_1.jsx("div", {
    className: className,
    css: videoContainerCss
  }, overlayVisible && core_1.jsx(VideoOverlay, null, core_1.jsx(video_play_button_1.default, {
    size: "lg",
    onClick: function onClick() {
      if (url) {
        setOverlayVisible(false);
        setIsPlaying(true);
      }

      _onClick();
    }
  })), placeholder && overlayVisible && core_1.jsx(VideoPlaceholder, null, placeholder()), url && core_1.jsx(react_player_1.default, Object.assign({}, rest, {
    css: reactPlayerCss,
    height: "100%",
    width: "100%",
    url: url,
    playing: isPlaying
  })));
};

exports.default = VideoPlayer;